var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enterView",on:{"click":_vm.pushRouter}},[_c('div',{staticClass:"enterTitle"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"enterSubTitle"},[_vm._v(" "+_vm._s(_vm.subTitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }